import { compose } from 'recompose'
import NewValuePropositionSmall from './NewValuePropositionSmall'

export default compose()(NewValuePropositionSmall)
